// Unique ids for elements of the bootstrap-vue replacements (bootstrap-vue itself uses __BVID__<number>).
let uid = 0

export const nextId = (name) => `__BVID__${name}_${++uid}`
